import styled from "styled-components";
export const AreaButton = styled.div`
	display: flex;
	top: 4rem;
	margin: -3rem 0 -0.4rem auto;
	gap: 1rem;

	> button {
		margin: 1rem 0;
	}

	@media (max-width: 560px) {
		margin: 0 0 1rem auto;
	}
`;

export const AreaButtonFilters = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 1rem;

	> button {
		max-width: fit-content !important;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		flex-direction: column;

		> button {
			width: 100%;
			max-width: unset !important;
			margin: 0;
		}
	}
`;

export const RowInputs = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
	margin-bottom: 16px;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		grid-template-columns: 1fr;
	}
`;
